import FlashSale from '@library/assets/images/icons/flash-sale.png';
import HotDog from '@library/assets/images/icons/hotdog.png';
import MoneyMouth from '@library/assets/images/icons/money-mouth.png';
import TacoIcon from '@library/assets/images/icons/taco.png';
import { cn } from '@library/component-utils/cn';
import { useMemo } from 'react';

export interface DiscountIndicatorProps {
  className?: string;
  discountName: string | null;
}

export const DiscountIndicator = ({
  className = '',
  discountName
}: DiscountIndicatorProps) => {
  const DiscountIcon = useMemo(() => {
    switch (discountName) {
      case 'taco':
        return <img src={TacoIcon} alt="Taco" />;
      case 'flash_sale':
        return <img src={FlashSale} alt="Flash Sale" />;
      case 'free_square':
        return <img src={MoneyMouth} alt="Money Mouth" />;
      case 'hotdog':
        return <img src={HotDog} alt="Hot Dog" />;
      default:
        return null;
    }
  }, [discountName]);

  return (
    <div className={cn('flex size-5 w-fit self-center', className)}>
      {DiscountIcon}
    </div>
  );
};
